import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminDepositService } from '@/modules/deposit/services/admin-deposit.service'
import { DepositRequestModel } from '@/modules/deposit/models/deposit-request.model'
import { DepositResourceModel } from '@/modules/deposit/models/deposit-resource.model'

@vservice()
export class DepositCreateUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminDepositService
  ) {
  }

  isLoading = false
  isSuccess = false

  execute(data: DepositResourceModel) {
    return this.service.store(this.requestData(data))
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }

  requestData(data: DepositResourceModel): DepositRequestModel {
    return {
      account_owner_name: data.account_owner_name,
      account_type: data.account_type,
      amount: data.amount,
      card_number: data.card_number,
      deposit_bank_account_id: data.bank_account?.id,
      description: data.description,
      economical_number: data.economical_number,
      national_id: data.national_id,
      paid_at: data.paid_at,
      payable_id: data.payable_id,
      payable_type: data.payable_type,
      reception: data.reception,
      reception_image: this.receptionImage(data.reception_image)[0],
      registered_name: data.registered_name,
      registered_number: data.registered_number,
      sheba: data.sheba,
      status: data.status,
      title: data.title,
      tracking_number: data.tracking_number,
      settlement_type: data.settlement_type || null,
      hidden: data.hidden || false
    }
  }

  receptionImage(array) {
    return array.filter(item => item instanceof File)
  }

}
